import { Logo } from "./ui/Logo";
import { LoadingDots } from "./ui/LoadingDots";

export const LoadingScreen = () => {
  return (
    <div className="flex h-[100dvh] w-full flex-col items-center justify-center gap-6 bg-bg-dark">
      <div className="animate-pulse-soft">
        <Logo variant="A" className="w-[160px]" />
      </div>
      <LoadingDots />
    </div>
  );
};
